<template>
  <div class="echarts">
      <div class="top">
        <div class="dataItem">
          <p class="data">{{companyCount.addBillCount}}</p>
          <p class="name">新增货源（个）</p>
        </div>
         <div class="dataItem">
          <p class="data" style="color: #ff9e00;">{{companyCount.accumulatedProfitCount}}</p>
          <p class="name">累计盈利（元）</p>
        </div>
         <div class="dataItem">
          <p class="data" style="color: #2cb190;">{{companyCount.shortCount}}</p>
          <p class="name">短期合作（个）</p>
        </div>
         <div class="dataItem">
          <p class="data">{{companyCount.longCount}}</p>
          <p class="name">长期合作（个)</p>
        </div>
      </div>
      <div class="bottom">
          <div class="bt">
            <div class="left">
              <div class="title">
                <h4>货源状态分布</h4>
                <div></div>
              </div>
              <div v-if="noData3" class="chartsBox nodata">
                 <img src="../../../assets/images/noDate.png" >
              </div>
              <div class="chartsBox" id="hyzt">  </div>
            </div>
            <div class="right">
              <div class="title">
                <h4>承运商统计</h4>
                <div>
                   <el-button type="text" size="mini" @click="carrierType('day')">日</el-button>
                   <el-button type="text" size="mini" @click="carrierType('month')">月</el-button>
                   <el-button type="text" size="mini" @click="carrierType('quarter')">季</el-button>
                   <el-button type="text" size="mini" @click="carrierType('year')">年</el-button>
                </div>
              </div>
               <div v-if="noData1" class="chartsBox nodata">
                 <img src="../../../assets/images/noDate.png" >
              </div>
               <div v-if="!noData1" class="chartsBox" id="cyscj"></div>
            </div>
          </div>
          <div class="bb">
             <div class="title">
                <h4>工作量统计</h4>
                <div>
                   <el-button type="text" size="mini" @click="worckType('day')">按月</el-button>
                   <el-button type="text" size="mini" @click="worckType('month')">按年</el-button>
                </div>
              </div>
              <div v-if="noData2" class="chartsBox nodata">
                 <img src="../../../assets/images/noDate.png" >
              </div>
               <div class="chartsBox" id="gzltj">  </div>
          </div>
      </div>
  </div>
</template>

<script>
import { dateWeightByUserId, statusCountByUserId, shipmentWeightCountByUserId, companyCount } from '@/api/soc-customer'
var echarts = require('echarts')
export default {
  data () {
    return {
      noData1: false,
      noData2: false,
      noData3: false,
      companyCount: {}
    }
  },
  created () {
    companyCount().then(res => {
      this.companyCount = res
    })
  },
  mounted () {
    this.goodsStatus()
    this.carrier('day')
    this.workload('month')
  },
  methods: {
    carrierType (type) {
      this.carrier(type)
    },
    worckType (type) {
      this.workload(type)
    },
    goodsStatus () {
      statusCountByUserId().then(res => {
        if (res.length < 1) {
          this.noData3 = true
        } else {
          this.noData3 = false
          myChartFn(res)
        }
      })
      function myChartFn (data) {
        var Adata = data
        var nameArr = []
        data.forEach(item => {
          nameArr.push(item.name)
        })
        var myChart = echarts.init(document.getElementById('hyzt'))
        var option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            bottom: 10,
            left: 'center',
            icon: 'circle',
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            data: Adata.name
          },
          color: ['#0c46a2', '#76aef6', '#ff9e00', '#2cb190', '#F56C6C', '#67C23A', '#409EFF'],
          series: [
            {
              name: '货源状态',
              type: 'pie',
              radius: ['30%', '60%'],
              center: ['50%', '40%'],
              data: Adata

            }
          ]
        }
        myChart.setOption(option)
      }
    },
    carrier (type) {
      shipmentWeightCountByUserId({ dateStr: type }).then(res => {
        if (res.name.length < 1) {
          this.noData1 = true
        } else {
          this.noData1 = false
          myChartFn(res)
        }
      })
      function myChartFn (data) {
        var Adata = data
        var myChart = echarts.init(document.getElementById('cyscj'))
        var option = {
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',
            top: '5%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: Adata.name,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '指派量（吨）',
              type: 'bar',
              barWidth: '60%',
              data: Adata.data
            }
          ]
        }
        myChart.setOption(option)
      }
    },
    workload (type) {
      dateWeightByUserId({ dateStr: type }).then(res => {
        if (res.name.length < 1) {
          this.noData2 = true
        } else {
          this.noData2 = false
          myChartFn(res)
        }
      })
      function myChartFn (data) {
        var Adata = data
        var myChart = echarts.init(document.getElementById('gzltj'))
        var option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',
            top: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: false,
              lineStyle: { color: '#999' }
            },
            data: Adata.name
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: { color: '#999' }
            }
          },
          tooltip: {
            trigger: 'none',
            axisPointer: {
              type: 'cross'
            }
          },
          series: [{
            data: Adata.data,
            type: 'line',
            itemStyle: {
              normal: {
                color: '#0e6fec'
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0, color: 'rgba(14,111,236,0.6)'
                }, {
                  offset: 1,
                  color: 'rgba(14,111,236,0.1)'
                }])
              }
            }
          }]
        }
        myChart.setOption(option)
      }
    }
  }

}
</script>

<style scoped lang='less'>
.echarts{
 background: #E5E5E5;
 padding: 10px 10px 10px 0;
 box-sizing: border-box;
  width:100%;
  height: calc(100% + 12px);
  margin-top: -12px;
  .top{
    width: 100%;
    height: 18%;
    background: #fff;
    display: flex;
    align-items:center;
    .dataItem{
      text-align: center;
      width: 25%;
      border-right: #ccc 1px solid;
      padding-bottom: 6px;
    }
 .dataItem:last-child{
   border:none
 }
    .data{
      font-size: 2em;
      text-align: center;
      color: #0e6fec;
      padding: 0;
      margin: 0;
    }
    .name{
      padding: 0;
      margin: 0;
      font-size: 14px;
    }
  }
  .bottom{
    width: 100%;
    height:82%;
    padding-top: 10px;
    box-sizing: border-box;
    .bt ,.bb{
    width: 100%;
    height:calc(50% - 5px);
    }
    .bb{
     background: #fff;
     margin-top: 10px;
    }
    .bt{
      display: flex;
      justify-content: space-between;
    }
    .left,.right{
      height:100%;
      width:calc(50% - 5px);
       background: #fff;
    }
    .title{
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
          height: 40px;
    align-items: center;
      h4{
            margin: 0;
    font-size: 16px;
    padding: 0;
    border-left: 3px solid #0e6fec;
    padding-left: 10px;
      }
    }
    .chartsBox{
      width:100%;
      height:calc(100% - 40px);
    }
  }
}
.nodata{
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width:130px;
    }
}
</style>
